import axios from "axios";
import {
    MODULE_BASE, MODULE_QUESTIONS_SAVE, RESPONSE_BASE, DELETE_MODULE_API, MODULE_QUESTIONS, DELETE_QUESTION_MODULE, COLLABORATION_LIST, QUESTION_VERSION,
    SUBMIT_SURVYE_RESPONSE, USER_ASSIGNED_COUNTRIES, UPDATE_USER_CURRENT_ACTIVE_COUNTRY, GET_LAST_YEAR_RESPONSE, SYNC_OFFLINE_RESPONSE_API, QUESTION_RAM_INTEGRATION,
    QUESTION_APPROVE,
    QUESTION_REJECT,
    ADD_REVIEW_COMMENT,
    GET_REVIEW_COMMENTS,
    QUESTION_ASSIGN_CREATOR
} from '../../constants/api';
import {
    MODULE, MESSAGE_FOR_UPDATED, MESSAGE_FOR_CREATED, QUESTION, MESSAGE_FOR_DELETED, SURVEY, MESSAGE_FOR_SUBMITTED, ACTIVE_COUNTRY, OFFLINE_RESPONSE,
    MESSAGE_FOR_SAVED,
    APPROVED_MESSAGE,
    REJECT_MESSAGE,
    ASSIGN_CREATOR_MESSAGE
} from 'src/constants/NotificationMessageConstant';
import { ShowException, ShowSuccessOrError } from '../utils/tostar';
import { history } from 'src/store/config';
import { toast } from 'react-toastify';
import { DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY, DATACOLLECTOR_DASHBOARD_KEY, DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY } from 'src/constants/constants';
import { getLocalStorageValue, clearLocalStorageValueForKey } from '../utils/local-storage';
import { AdminQuestionStatus } from '../../constants/Enum/ModuleEnum';


export const getModuleListCall = async () => {
    return await axios.get(MODULE_BASE)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const getModuleListBySurveyCall = async (data: any) => {
    return await axios.get(MODULE_BASE + `/survey/${data.payload.isDashboard ? data.payload.surveyId : data.payload}`)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const getEditModuleMetadataCall = async (data: any) => {
    return await axios.get(MODULE_BASE + '/' + data.payload)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const getModulePreviewCall = async (data: any) => {
    const resp = await axios.get(MODULE_BASE + '/preview/' + data.payload.moduleId)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const saveModuleCall = async (data: any) => {
    const resp = axios.post(MODULE_BASE, data)
        .then((res: any) => {
            ShowSuccessOrError(MODULE + MESSAGE_FOR_CREATED, res);
            history.push('/modules');
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const updateModuleCall = async (data: any) => {
    const resp = axios.put(MODULE_BASE, data)
        .then((res: any) => {
            ShowSuccessOrError(MODULE + MESSAGE_FOR_UPDATED, res);
            history.push('/modules');
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}


export const saveModuleQuestionsCall = async (data: any) => {
    const resp = axios.post(MODULE_QUESTIONS_SAVE + data.id, data.moduleQuestion)
        .then((res: any) => {
            ShowSuccessOrError(QUESTION + MESSAGE_FOR_UPDATED, res);
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const saveResponseCall = async (data: any) => {
    const resp = axios.post(RESPONSE_BASE, data.payload)
        .then((res: any) => {
            if (toast.isActive(2)) {
                toast.dismiss();
            }
           // commented code to stop update response message  
           // ShowSuccessOrError(RESPONSE + MESSAGE_FOR_UPDATED, res);
           return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getSurveyResponseCall = async (data: any) => {
    const resp = await axios.get(RESPONSE_BASE + `/${data.payload.countryModuleSurveyMappingId}`)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getSurveyResponseOfflineCall = async (data: any) => {
    const localStorageuserData = getLocalStorageValue('user');
    const userId = localStorageuserData.id;
    const countryModuleSurveyMappingId = data.payload.countryModuleSurveyMappingId;
    const moduleResponse = getLocalStorageValue(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}_${countryModuleSurveyMappingId}`);
    return moduleResponse
}


export const syncOfflineResponseCall = (data: any) => {
    const resp = axios.post(SYNC_OFFLINE_RESPONSE_API, data.payload)
        .then((res: any) => {
            const localStorageuserData = getLocalStorageValue('user');
            const userId = localStorageuserData.id;

            for (const key in localStorage) {
                if (key.indexOf(`UserId_${userId}_${DATACOLLECTOR_COUNTRY_MODULE_SURVEY_KEY}`) !== -1) {
                    clearLocalStorageValueForKey(key);
                }
            }

            clearLocalStorageValueForKey(`UserId_${userId}_${DATACOLLECTOR_DASHBOARD_KEY}`);
            clearLocalStorageValueForKey(`UserId_${userId}_${DATACOLLECTOR_IS_OFFLINE_ACTIVE_KEY}`);

            ShowSuccessOrError(OFFLINE_RESPONSE + MESSAGE_FOR_SAVED, res);
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const deleteModuleCall = (data: any) => {
    const resp = axios.put(DELETE_MODULE_API + data.payload)
        .then((res: any) => {
            ShowSuccessOrError(MODULE + MESSAGE_FOR_DELETED, res)
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getModuleQuestionsCall = async (data: any) => {
    return await axios.get(`${MODULE_QUESTIONS}/${data}`)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const getAllComments = async (data: any) => {
    return await axios.get(`${COLLABORATION_LIST}/${data.countryModuleSurveyMappingId}/questions/${data.questionId}`)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const addComment = async (data: any) => {
    return await axios.post(`${COLLABORATION_LIST}`, data)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
}


export const deleteQuestionFromModuleCall = async (moduleId: any, questionId: any) => {
    return await axios.delete(`${DELETE_QUESTION_MODULE}/${moduleId}/${questionId}`)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
}


export const getQuestionsWithAllVersionCall = async (moduleId: any, questionId: any) => {
    return await axios.get(`${QUESTION_VERSION}/${moduleId}/${questionId}`)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const submitSurveyResponseCall = async (countryModuleSurveyMappingId: any, surveyId?: number) => {
    const resp = await axios.post(SUBMIT_SURVYE_RESPONSE + "?countryModuleSurveyMappingId=" + countryModuleSurveyMappingId)
        .then((res: any) => {
            ShowSuccessOrError(SURVEY + MESSAGE_FOR_SUBMITTED, res);
            history.push("/Data-Collector-survey-response/" + surveyId);
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getCountriesAssignedToUserCall = async () => {
    return await axios.get(USER_ASSIGNED_COUNTRIES)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
}

export const updateCurrentActiveCountryCall = async (countryId: any) => {
    const resp = await axios.put(UPDATE_USER_CURRENT_ACTIVE_COUNTRY + `/${countryId}`)
        .then((res: any) => {
            ShowSuccessOrError(ACTIVE_COUNTRY + MESSAGE_FOR_UPDATED, res);
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getlastyearresponseCall = async (data: any) => {
    const resp = await axios.get(GET_LAST_YEAR_RESPONSE + `/${data.questionId}/countrymodulesurveymapping/${data.countryModuleSurveyMappingId}`)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getRamIntegrationDataCall = async (data: any) => {
    const resp = await axios.get(QUESTION_RAM_INTEGRATION + `/${data.ramIntegrationQuestionIndicatorCode}/countrymodulesurveymapping/${data.countryModuleSurveyMappingId}`)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

// api to approve the question
export const approveQuestionCall = (data: any, adminQuestionStatus: AdminQuestionStatus) => {
    const apiUrl = adminQuestionStatus === AdminQuestionStatus.Reject ? QUESTION_REJECT : (adminQuestionStatus === AdminQuestionStatus.AssignToCreator ? QUESTION_ASSIGN_CREATOR : QUESTION_APPROVE);
    const resp = axios.put(apiUrl, data.payload)
        .then((res: any) => {
            ShowSuccessOrError(adminQuestionStatus === AdminQuestionStatus.Reject ? REJECT_MESSAGE : (adminQuestionStatus === AdminQuestionStatus.AssignToCreator ? ASSIGN_CREATOR_MESSAGE : APPROVED_MESSAGE), res)
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });

    return resp;
}

// add review comments
export const addReviewComment = (data: any) => {
    const resp = axios.post(`${ADD_REVIEW_COMMENT}`, data)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });

    return resp;
}

// get all review questions comments
export const getAllReviewQuestionsComments = async (data: any) => {
    const resp = axios.get(`${GET_REVIEW_COMMENTS}/${data.questionId}`)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });

    return resp;
}


// WEBPACK FOOTER //
// ./src/effects/api/api.module.tsx